import React from 'react';
import { Box, Typography } from '@mui/material';

const styles = {
    item: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        p: '10px',
        borderRadius: '8px',
        border: '1px solid rgba(255,255,255,0.10)',
        transition: 'border-color 0.18s ease',
        '&:hover': {
            borderColor: 'rgba(0, 215, 255, 0.35)',
        },
    },
    name: {
        fontSize: '0.875rem',
        color: 'var(--ecal-white)',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flex: 1,
        minWidth: 0,
    },
    action: {
        fontSize: '0.72rem',
        color: 'var(--ecal-lightblue)',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        flexShrink: 0,
        padding: 0,
        fontFamily: 'inherit',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
};

function ScheduleEntry({ schedule, actionLabel, onAction }) {
    const name = schedule.scheduleName || schedule.name || 'Unnamed schedule';
    const id = schedule.scheduleId || schedule.id;

    return (
        <Box sx={styles.item}>
            <Typography sx={styles.name}>{name}</Typography>
            <Box
                component="button"
                onClick={() => onAction(id)}
                sx={styles.action}
            >
                {actionLabel}
            </Box>
        </Box>
    );
}

export default ScheduleEntry;
